import { render, staticRenderFns } from "./HelpdeskTicketsDetail.vue?vue&type=template&id=f398870a"
import script from "./HelpdeskTicketsDetail.vue?vue&type=script&lang=js"
export * from "./HelpdeskTicketsDetail.vue?vue&type=script&lang=js"
import style0 from "./HelpdeskTicketsDetail.vue?vue&type=style&index=0&id=f398870a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports